export default __webpack_public_path__ + "static/media/6.646406d8.jpg";